import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu', 'option'];

  connect() {
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleEscape = this.handleEscape.bind(this);

    this.optionTargets.forEach((option) => {
      option.addEventListener('click', () => this.hide());
    });
  }

  disconnect() {
    this.optionTargets.forEach((option) => {
      option.removeEventListener('click', () => this.hide());
    });

    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleEscape);
  }

  toggle() {
    const isVisible = !this.menuTarget.classList.contains('hidden');

    if (isVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    const dropdown = this.menuTarget;
    dropdown.classList.remove('hidden', 'opacity-0', 'scale-95');

    const rect = dropdown.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < dropdown.offsetHeight && spaceAbove > dropdown.offsetHeight) {
      dropdown.classList.add('bottom-full', 'mb-2');
    } else {
      dropdown.classList.remove('bottom-full', 'mb-2');
    }

    requestAnimationFrame(() => {
      dropdown.classList.add('opacity-100', 'scale-100');
    });

    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.handleEscape);
  }

  hide() {
    const dropdown = this.menuTarget;

    dropdown.classList.remove('opacity-100', 'scale-100');
    dropdown.classList.add('opacity-0', 'scale-95');

    setTimeout(() => {
      dropdown.classList.add('hidden');
      dropdown.classList.remove('bottom-full', 'mb-2');
    }, 150);

    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleEscape);
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide();
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.hide();
    }
  }

  press(event) {
    event.currentTarget.classList.add('bg-black-50');
  }

  release(event) {
    event.currentTarget.classList.remove('bg-black-50');
  }
}
